import * as React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../theme';
import { planeIcon } from '../../../../BoardingPassDesk/Icons';
import { format } from '../../../../utils';
import { CheckoutSegmentProps } from '../../../types';

const SegmentCommon: React.FC<CheckoutSegmentProps> = ({ segment }) => {
	const { SegmentCommon: css } = useTheme('RetrieveBooking');
	const { t } = useTranslation('Segment');

	const currentDate = new Date();
	const fareFamily = segment.fareFamily;

	const currentSegment = segment.segments[0];

	return (
		<div className={css.wrapper}>
			<div className={cn(css.header)}>
				<div className={css.flightInfo}>
					<div className={css.flightInfo__item}>
						<span className={css.flightInfo__title}>{t('Flight')}</span>

						<span className={cn(css.flightInfo__value, css.flightInfo__valueBold)}>
							{currentSegment.operatingAirline.iata} {currentSegment.flightNumber}
						</span>
					</div>

					<div className={css.flightInfo__item}>
						<span className={css.flightInfo__title}>{t('Departure')}</span>
						<span className={css.flightInfo__value}>
							{format(
								currentSegment.departure.date,
								`${
									new Date(currentSegment.departure.date).getFullYear() - currentDate.getFullYear() >
									0
										? 'dd MMM yyyy'
										: 'dd MMMM'
								}`
							)}
						</span>
					</div>
				</div>

				<div className={css.cities}>
					<div className={css.city}>
						<span className={css.city__airport}>{currentSegment.departure.airport.name}</span>

						<span className={css.city__info}>
							<span className={css.city__iata}>{currentSegment.departure.airport.iata}</span>
							<span className={css.city__time}>{currentSegment.departure.time.substr(0, 5)}</span>
						</span>
					</div>

					<span className={css.plane__icon}>{planeIcon}</span>

					<div className={css.city}>
						<span className={css.city__airport}>{currentSegment.arrival.airport.name}</span>

						<span className={css.city__info}>
							<span className={css.city__iata}>{currentSegment.arrival.airport.iata}</span>
							<span className={css.city__time}>{currentSegment.arrival.time.substr(0, 5)}</span>
						</span>
					</div>
				</div>
			</div>

			<div className={css.footer}>
				<div className={css.footer__airline}>
					<span>
						{fareFamily?.airline?.icon && (
							<img
								className={css.airline__logo}
								alt={fareFamily?.airline?.name}
								src={fareFamily?.airline?.icon}
							/>
						)}
						<span className={css.airline__name}>
							{fareFamily?.airline?.name && `${fareFamily.airline.name}, `}
							{fareFamily?.title?.toLowerCase()}
						</span>
					</span>
				</div>
				<div className={css.footerItems}>
					<div className={css.footerItems__item}>
						<span className={css.footerItems__title}>{t('Terminal')}</span>
						<span className={css.footerItems__value}>{currentSegment.departure.terminal}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SegmentCommon;
